module.exports = __webpack_public_path__ + "static/media/Logo.0a4ba95b.svg";